import { useState } from 'react';
import {
	Button,
	Dialog,
	IconButton,
	Input,
} from '@material-ui/core';
import {
	Search as SearchIcon,
} from '@material-ui/icons';

import useStyles from './SearchLocations.styled';
import { useWeather } from '../../hooks/Weather';

const SearchLocations = () => {
	const classes = useStyles();
	const { getWeather } = useWeather();
	const [open, setOpen] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const submitWeather = (event) => {
		event.preventDefault();
		setOpen(false);
		getWeather({
			city: event.target.elements.city.value,
			country: event.target.elements.country.value,
		});
	};

	return (
		<>
			<IconButton
				className={classes.searchButton}
				aria-label="more"
				aria-controls="settings-menu"
				aria-haspopup="true"
				color="inherit"
				onClick={handleOpen}
			>
				<SearchIcon />
			</IconButton>

			{/* TODO: Change to a search box that transitions in when you click the button above */}
			<Dialog
				open={open}
				onClose={handleClose}
			>
				<form
					className={classes.form}
					autoComplete="off"
					onSubmit={submitWeather}
				>
					<Input
						className={classes.formInput}
						name="city"
						placeholder="Town or city"
						inputProps={{
							'aria-label': 'Town or city',
						}}
					/>
					<Input
						className={classes.formInput}
						name="country"
						placeholder="Country code"
						inputProps={{
							'aria-label': 'Country code',
						}}
					/>
					<Button
						className={classes.formButton}
						color="primary"
						type="submit"
					>
						Add Location
					</Button>
				</form>
			</Dialog>
		</>
	);
};

export default SearchLocations;
